import * as R from 'ramda'
import assign from 'lodash/fp/assign'
import compose from 'lodash/fp/compose'
import transform from 'lodash/fp/transform'

export function _create_key(target, by) {
    if (by instanceof Array) {
        return R.compose(

            R.join('-'),

            R.map(property => R.prop(property, target) )
        )(by)
    } else {
        return target[by]
    }
}

export function set({ to }) {
    return (state, payload) => {

        // Objekt hinzufuegen
        state[to] = { ...state[to], ...payload['content'] }
    }
}

export function set_one({ to, by = 'id' })  {
    return (state, payload) => {
        // Objekt, das hinzugefuegt werden soll
        const target = payload['content']

        // Key unter dem das Objekt hinzugefuegt werden soll
        const key = _create_key(target, by)

        // Objekt hinzufuegen
        state[to] = { ...state[to], [key]: target }
    }
}

export function set_many({ to, by = 'id' })  {
    return (state, payload) => {
        // Objekte, die hinzugefuegt werden sollen
        const targets = payload['content']

        state[to] = compose([

            // `values` in State setzen
            assign(state[to]),

            // `targets`-Array zu Objekt transformieren, das als Property-Keys die IDs des jeweiligen `target` nutzt
            transform((result, target) => result[_create_key(target, by)] = target, {})

        ])(targets)
    }
}

export function remove({ from, by = 'id' }) {
    return (state, payload) => {
        // Status klonen
        const values = { ...state[from] }

        // Zu loeschenden Key ermitteln
        const key = payload['content'][by]

        // Eintrag loeschen
        delete values[key]

        // Objekte setzen
        state[from] = values
    }
}


export function ADD_PENDING(state, { promise, id }) {
    state.pendings = { ...state.pendings, [id]: promise }
}

export function ADD_REQUEST(state, { id, promise }) {
    state.requests = { ...state.requests, [id]: promise }
}

export function REMOVE_PENDING(state, { id }) {
    const pendings = { ...state.pendings }
    delete pendings[id]
    state.pendings = pendings
}

export function REMOVE_REQUEST(state, { id }) {
    const requests = { ...state.requests }
    delete requests[id]
    state.pendings = requests
}
